import React, { useState } from 'react';
import { ariaSortOrders } from './types';
export var TableContext = React.createContext({
    updateSort: function () { return null; },
    getSort: function () { return 'none'; },
});
var getNextSort = function (sort) {
    if (sort === void 0) { sort = 'none'; }
    return sort
        ? ariaSortOrders[(ariaSortOrders.indexOf(sort) + 1) % ariaSortOrders.length]
        : 'none';
};
export var TableProvider = function (_a) {
    var _b;
    var initialSort = _a.initialSort, children = _a.children;
    var _c = useState((_b = initialSort === null || initialSort === void 0 ? void 0 : initialSort.sortOrder) !== null && _b !== void 0 ? _b : 'none'), activeSortOrder = _c[0], setActiveSortOrder = _c[1];
    var _d = useState(initialSort === null || initialSort === void 0 ? void 0 : initialSort.sortKey), activeSortKey = _d[0], setActiveSortKey = _d[1];
    var updateSort = function (sortKey) {
        if (sortKey === activeSortKey) {
            setActiveSortOrder(getNextSort(activeSortOrder));
        }
        else {
            setActiveSortKey(sortKey);
            setActiveSortOrder(getNextSort('none'));
        }
    };
    var getSort = function (sortKey) {
        if (sortKey === activeSortKey) {
            return activeSortOrder;
        }
        return 'none';
    };
    return (React.createElement(TableContext.Provider, { value: { activeSortOrder: activeSortOrder, activeSortKey: activeSortKey, updateSort: updateSort, getSort: getSort } }, children));
};
